const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Início",
    to: "/",
  },
  {
    text: "Peças",
    to: "/pecas",
  },
  {
    text: "Ferramentas",
    to: "/ferramentas",
  },
  {
    text: "Serviços",
    to: "/servicos",
  },
  {
    text: "Contato",
    to: "/contato",
  },
];

export { server, menu };
